export default __webpack_public_path__ + "static/media/donburi.ba688543.svg";